export const styles = (theme) => ({
  paper: {
    padding: "2rem",
  },
  list: {
    maxHeight: "12rem",
    overflow: "auto",
  },
  loadMore: {
    textAlign: "center",
    cursor: "pointer",
    color: "#3f51b4",
    textDecoration: "underline",
    fontWeight: "bold",
  },
});
